import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// translation.json is fetched at runtime and the host sends no Cache-Control,
// so browsers kept a stale copy across deploys and new copy showed up as raw
// keys. The build script stamps every build with a fresh id to bust that.
const buildId = process.env.REACT_APP_BUILD_ID || 'dev';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: buildId },
    },

    detection: {
      order: [
        'path',
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'navigator',
        'htmlTag',
        'subdomain'
      ],
      lookupFromPathIndex: 0,
      caches: ['localStorage', 'cookie'],
      excludeCacheFor: ['cimode'],
      cookieMinutes: 160,
      cookieDomain: 'notely.se',
    },

    supportedLngs: ['en', 'es', 'fr', 'de', 'pt', 'vi', 'sv', 'ro'],
    nonExplicitSupportedLngs: true,
    
    react: {
      useSuspense: false,
    },
  });

export default i18n;